import sendRequest from "./send-request";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function signUp(userData) {
 return sendRequest(`${BASE_URL}/users`, "POST", userData)
}

export async function login(credentials) {
    return sendRequest(`${BASE_URL}/users/login`, "POST", credentials)
}

export async function checkToken() {
    return sendRequest(`${BASE_URL}/users/check-token`)
}

// ADDING 10.5.25

    export function addCompletedCaseId(caseId) {
        // backend base is /users
        return sendRequest(`${BASE_URL}/users/completed-case`, 'POST', { caseId });
    }


// at bottom with other exports - added 10.21.25 to get all users
export async function listAllUsers() {
    // sendRequest already knows BASE_URL and (usually) adds the token header
    return sendRequest(`${BASE_URL}/users`, "GET");
  }